import React from 'react';

type Severity = 'critical' | 'high' | 'medium' | 'low' | 'normal' | string;

// Non-clinical status tones (--status-*), never --band-* — this badges care
// plan/task priority, not an organ score (SPEC rule 4 reserves severity color
// for organ scores only).
const severityStyles: Record<string, string> = {
  critical: 'bg-status-negative-bg text-status-negative-text border-(--status-negative)/30',
  high: 'bg-status-negative-bg text-status-negative-text border-(--status-negative)/20',
  medium: 'bg-status-attention-bg text-status-attention-text border-(--status-attention)/30',
  low: 'bg-status-positive-bg text-status-positive-text border-(--status-positive)/30',
  normal: 'bg-surface-sunken text-text-tertiary border-border',
};

export function SeverityBadge({
  value,
  fallback = 'normal',
}: {
  value: string;
  fallback?: Severity;
}) {
  const normalized = (String(value || fallback).toLowerCase() || 'unknown') as Severity;
  const style =
    severityStyles[normalized] ??
    severityStyles[fallback] ??
    'bg-surface-sunken text-text-tertiary border-border';

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${style}`}
    >
      {value || fallback}
    </span>
  );
}
